const LEVEL_RANK = { none: 0, view_only: 1, full: 2 };

export const getStoredPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem('PERMISSIONS') || 'null');
  } catch {
    return null;
  }
};

export const hasPermission = (featureCode, minLevel = 'view_only') => {
  const perms = getStoredPermissions();
  if (!perms) return false;
  if (perms.isSuperAdmin) return true;

  const level = perms.features?.[featureCode] ?? 'none';
  return (LEVEL_RANK[level] ?? 0) >= (LEVEL_RANK[minLevel] ?? 0);
};
